import Rest from '../services/rest'
import {store} from '../store/store'

/**
 * @typedef {LiberacaoPagamentoService}
 */
export default class LiberacaoPagamentoService{

    constructor() {
        this.resource = "/financeiro/liberacaopagamento"

        this.http = Rest.build(store.getters.token, this.resource);
    }

    static build() {
        return new this();
    }

    get_all(status='not_payed'){       
        return this.http.get(`/status/${status}`);
    }

   /*liberar_periodo(params){
        return this.http.post('/save', params)
    }*/


}